import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { ButtonContext } from './Button';

export default function ButtonText({ children, className, ...restProps }) {
  useContext(ButtonContext, 'Button.Text must be a child of Button');

  return (
    <span
      className={mergeClasses(
        'px-1 font-sans text-base font-semibold text-black',
        className
      )}
      {...restProps}
    >
      {children}
    </span>
  );
}

ButtonText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

ButtonText.defaultProps = {
  className: ''
};
